import React from "react";
import Fire from "../../icons/Fire.svg";

const TotalStreaksCard = () => {
  return (
    <div className="w-full max-w-[224px] h-52 bg-black rounded-2xl shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] text-white flex flex-col items-center justify-center p-4">
      {/* Fire Icon with animation */}
      <div className="relative w-14 h-16 mb-3 flex items-center justify-center">
        <img
          src={Fire}
          alt="Fire Streak Icon"
          className="w-12 h-12 animate-pulse drop-shadow-[0_0_10px_rgba(59,130,246,0.7)]"
        />
      </div>

      {/* Label */}
      {/* <p className="text-sm font-medium text-gray-200">Total Streaks</p> */}

      {/* Placeholder value */}
      {/* <span className="text-lg font-bold text-cyan-400 mt-1">0</span> */}
    </div>
  );
};

export default TotalStreaksCard;
